import { BorderRight } from "@mui/icons-material";
import { LuSearch, LuChevronDown } from "@/Components/Icons/Icons";
export default {
  row1: [
    {
      column: "column1",
      columnWidth: "55%",
      rows: {
        row1: [
          {
            name: "isBuyerandSeller",
            checkboxLabel: "Are Buyer & Seller Related",
            component: "checkboxBox",
          },
        ],
        row2: [
          {
            name: "importInvoiceSvbRelation",
            label: "Relation",
            component: "text-field",
            width: "95%",
          },
        ],
        row3: [
          {
            name: "importInvoiceSvbbase",
            label: "Base",
            component: "text-field",
            width: "95%",
          },
        ],
        row4: [
          {
            name: "importInvoiceSvbCondition",
            label: "Condition",
            component: "text-field",
            width: "95%",
          },
        ],
      },
    },

    {
      column: "column2",
      columnWidth: "53%",
      rows: {
        row1: [
          {
            name: "isSvbLoading",
            checkboxLabel: "SVB Loading",
            component: "checkboxBox",
            icon: LuSearch,
          },
        ],
        row2: [
          {
            name: "importInvoiceSvbRefNo",
            label: "SVB Ref No.",
            component: "text-field",
            width: "50%",
          },
          {
            name: "importInvoiceSvbRefDate",
            component: "DateSelector",
            width: "50%",
          },
        ],
        row3: [
          {
            name: "importInvoiceCustomHouse",
            label: "Custom House",
            component: "text-field",
            icon: LuSearch,
            endpoint: "getCustomeHouse",
            type: "autocomplete",
          },
        ],
        row4: [
          {
            name: "importInvoiceLoadingon",
            label: "Loading On",
            component: "dropdown",
            options: [
              { label: "Assessable", value: "Assessable" },
              { label: "duty", value: "duty" },
              { label: "Assessable&duty", value: "Assessable&duty" },
            ],
          },
        ],
        row5: [
          {
            name: "importInvoiceRateAssbl",
            label: "Rate(Assbl.)",
            component: "text-field",
            width: "90%",
            dataType:"float",
            placeholder:"0.0000"

          },
          {
            name: "cond",
            label: "%",
            component: "typhographytext",
          },
          {
            name: "importInvoiceRateAssblStatus",
            label: "Status",
            component: "dropdown",
            endIconName: LuChevronDown,
            iconColor: "gray-400",
            width: "90%",
            options: [
              { label: "provisional", value: "provisional" },
              { label: "Final", value: "Final" },
            ],
          },
        ],
        row6: [
          {
            name: "importInvoiceRateDuty",
            label: "Rate(Duty)",
            component: "text-field",
            width: "90%",
            dataType:"float",
            placeholder:"0.0000"

          },
          {
            name: "cond",
            label: "%",
            component: "typhographytext",
          },
          {
            name: "importInvoiceRateDutyStatus",
            label: "Status",
            component: "dropdown",
            width: "90%",
            options: [
              { label: "provisional", value: "provisional" },
              { label: "Final", value: "Final" },
            ],
          },
        ],
      },
    },
  ],
};
